import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";

const IMG_COMMUNITY = "https://images.unsplash.com/photo-1490730141103-6cac27aaab94?auto=format&fit=crop&w=2000&q=80";

export default function Historia() {
  const { t } = useLang();

  return (
    <div data-testid="historia-page">
      <section className="relative pt-40 pb-24 overflow-hidden">
        <div className="absolute inset-0" aria-hidden="true">
          <img src={IMG_COMMUNITY} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/40" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-10">
          <Reveal>
            <Overline>{t.historia.overline}</Overline>
            <h1 className="font-display text-5xl md:text-7xl font-light tracking-tight mt-6 max-w-3xl">
              {t.historia.title}
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-white/70 text-lg leading-relaxed max-w-2xl mt-10">
              {t.historia.intro}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-24" data-testid="timeline">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {t.historia.timeline.map((item, i) => (
            <Reveal key={item.year} delay={i * 0.1}>
              <div className="border-t border-white/15 pt-8">
                <span className="font-display text-6xl font-light text-ember/80">{item.year}</span>
                <h3 className="text-lg font-medium mt-6 mb-3">{item.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-t border-white/10 bg-coal" data-testid="beliefs">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
          <Reveal>
            <Overline>{t.historia.beliefsOverline}</Overline>
            <h2 className="font-display text-4xl md:text-6xl font-light mt-4 mb-16">
              {t.historia.beliefsTitle}
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12">
            {t.historia.beliefs.map((b, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="flex gap-8 items-start border-b border-white/10 pb-10">
                  <span className="font-display text-4xl font-light text-ember shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="font-display text-3xl font-light mb-3">{b.title}</h3>
                    <p className="text-white/60 leading-relaxed">{b.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
